import React from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
// import GitHubLogin from 'react-github-login';
import { Redirect } from 'react-router';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import GTranslateIcon from '@material-ui/icons/GTranslate';
import GitHubIcon from '@material-ui/icons/GitHub';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import axios from 'axios';

import md5 from 'md5';

import {
  Link
} from "react-router-dom";

class AdminLogin extends React.Component{
    constructor(props){
            super(props);

            this.state = {
                email:'',
                password:"",
                isTrueLogin: false,
                accessToken:"",
                resToken:"",
            }

            this.onChangeEmail = this.onChangeEmail.bind(this);           
            this.onChangePass = this.onChangePass.bind(this);           
            this.onSubmit = this.onSubmit.bind(this);           

        }

    componentDidMount(){
        
    }


    onChangeEmail(e){
        const email = e.target.value;
        this.setState({
            email:email
        })
    }

    onChangePass(e){
        const password = e.target.value;
        this.setState({
            password:password
        })
    }


    onSubmit(e){
        e.preventDefault();
        var {email, password} = this.state;
        document.cookie = `${md5(email)}`
        document.cookie = `${md5(password)}`
        var cookie = document.cookie
        if(cookie === "0fe8cf3262d72131ec5d304cd3d8190b"){
            this.setState({isTrueLogin : true})
        }
        // this.setState({redirect : 200})
        // var username = getCookie("username");
  
    }

    resToken=()=>{
        axios.get(`https://graph.facebook.com/v6.0/oauth/access_token?grant_type=fb_exchange_token&client_id=313201206487594&client_secret=effb6a36ca65a95878321869bc67c492&fb_exchange_token=${this.state.accessToken}`).then(res =>{
            this.setState({resToken:res.data.access_token})
            console.log(res.data)
        })
    }






    render(){
        const responseFacebook = (response) => {
          console.log(response);
          this.setState({accessToken:response})
        }
        return(
            <div>
                <div className="">
                </div>
                {this.state.isTrueLogin === true ? <Redirect to='/manager'  /> : ""}
                <div className={`container-fluid-css container-fluid ${this.state.loading12}`}  style={{background:"#fff", height:"100vh"}}>
                    <div className="row header">
                        <div className="col-12 col-sm-12 col-lg-12 col-xl-12">
                            <div className="login-left">
                                
                                <div className="main_banner_e">
                                    <div className="banner_e"></div>
                                </div>

                                <form onSubmit={this.onSubmit} className="formLogin">
                            
                                        <FacebookLogin
                                          appId="313201206487594"
                                          autoLoad
                                          callback={responseFacebook}
                                          render={renderProps => (
                                            <button onClick={renderProps.onClick}>This is my custom FB button</button>
                                          )}
                                        />
                                    <div className="input-login">

                                        <div className="icone_user">
                                        <AccountCircleIcon />
                                        <input 
                                               type="email"
                                               name="email"
                                               placeholder="Username or email"
                                               onChange={this.onChangeEmail}
                                                />
                                        </div>
                                        
                                        <br/>
                                        <div className="icone_user">
                                        <LockOpenIcon />
                                        <input placeholder="Password" 
                                               type="password"
                                               name="password"
                                               onChange={this.onChangePass}
                                                />
                                        </div>
                                    </div>
                                    <div className="button-login">
                                        <button type="submit" className="btn btn-primary">Login</button>
                                        <span>forget password</span>
                                    </div>
                                    
                                </form>
                                <button onClick={this.resToken}>res</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AdminLogin;